export default __webpack_public_path__ + "static/media/EM1030.34I-29211_-16955_0.d2e69838.jpg";